import { ORDER_BY_OPTIONS, ORDER_OPTIONS, PER_PAGE_OPTIONS } from '@/admins/SmartReports/constants';
import { createContext, useContext, useEffect, useState } from 'react';

const SmartReportListContext = createContext();

const SmartReportListProvider = ({ children }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(PER_PAGE_OPTIONS[0]);
  const [order, setOrder] = useState(ORDER_OPTIONS[0].value);
  const [orderBy, setOrderBy] = useState(ORDER_BY_OPTIONS[0].value);

  // Reset page when search, order, orderBy, or perPage changes
  useEffect(() => setPage(0), [search, order, orderBy, perPage]);

  return (
    <SmartReportListContext.Provider
      value={{
        search,
        setSearch,
        page,
        setPage,
        perPage,
        setPerPage,
        order,
        setOrder,
        orderBy,
        setOrderBy,
      }}
    >
      {children}
    </SmartReportListContext.Provider>
  );
};

const useSmartReportList = () => useContext(SmartReportListContext);

export { SmartReportListProvider, useSmartReportList };
